import { gwc_attr, gwc_qs, gwc_qsa, gwc_parent } from './give-wc-helpers';

/**
 * This class is for getting, formatting and unformatting the
 * amount value.
 *
 * @since 1.0.0
 */
export class Give_WC_Amount {

    /**
     * Get and set the amount, args and form selector.
     *
     * @since 1.0.0
     *
     * @param {double} amount
     * @param {Object} args
     * @param {Object} form
     */
    constructor(amount, args, form) {

        this.amount = amount || 0.00;
        this.form = form || {};

        // Set default values if not passed.
        this.args = Object.assign({
            symbol: '',
            position: give_wc_vars.currency_settings.currency_position,
            decimal: give_wc_vars.currency_settings.decimal_sep,
            thousand: give_wc_vars.currency_settings.thousand_sep,
            precision: parseInt(give_wc_vars.currency_settings.decimal_numbers),
            currency: give_wc_vars.currency_settings.currency,
        }, args);
    }

    /**
     * Get the Donation Form amount.
     *
     * @since 1.0.0
     *
     * @param {int} form_id
     */
    getAmount(form_id) {

        // Get the amount field.
        let amount_field = gwc_qs('#give-wc-form-' + $form_id + ' input#give-amount').value;

        // Return amount.
        return amount_field.value || false;
    }

    /**
     * Get the format amount.
     *
     * @since 1.0.0
     */
    formatAmount() {
        return Give.fn.formatCurrency(this.amount, this.args, this.form);
    }

    /**
     * Unformat the amount value and return.
     *
     * @since 1.0.0
     * @param {string} decimal_separator
     */
    unFormatAmount(decimal_separator, amount) {
        let decimal = decimal_separator || this.args.decimal;
        let currentAmount = amount || this.amount;

        return Give.fn.unFormatCurrency(currentAmount, decimal);
    }

    /**
     * Verify the passed value for min/max amount.
     *
     * @since 1.0.0
     * @param {int} form_id
     */
    verifyAmount(form_id) {

        // Get the Minimum and Maximum Amount.
        let currentAmount = this.unFormatAmount(this.args.decimal, this.amount),
            min_amount = parseFloat(gwc_attr(form_id, 'minimum')),
            max_amount = parseFloat(gwc_attr(form_id, 'maximum')),
            flag = true;

        // Get the buttons.
        const
            btn_on_cart = gwc_qs('form.woocommerce-cart-form button[name="update_cart"],form.woocommerce-cart-form *[name="update_cart"] '),
            btn_on_checkout = gwc_qs('form.woocommerce-checkout button#give_wc_update_donation');

        // Get the donation form row.
        let formRow = gwc_qs('.give-wc-give-form-row[data-form_id="' + form_id + '"]');

        // Get the amount field.
        let amountField = gwc_qs('.give-wc-amount-field', formRow);

        // Get the tooltip.
        let tooltip = gwc_parent(amountField, 'span');

        // Check minimum/maximum validation.
        if (currentAmount < min_amount || currentAmount > max_amount) {
            const
                minMaxAmount = currentAmount < min_amount ? formRow.dataset.minimum : formRow.dataset.maximum,
                formatAmount = new Give_WC_Amount(minMaxAmount, { symbol: give_global_vars.currency_sign }).formatAmount(currentAmount),
                errorMessage = currentAmount < min_amount ? give_global_vars.bad_minimum : give_global_vars.bad_maximum;

            tooltip.setAttribute('aria-label', `${errorMessage} ${formatAmount}`);

            // Block the buttons.
            if (null !== btn_on_cart) {
                btn_on_cart.setAttribute('disabled', '');
                tooltip.classList.remove('give_wc_hide_tooltip');
            }

            if (null !== btn_on_checkout) {
                btn_on_checkout.setAttribute('disabled', '');
                tooltip.classList.remove('give_wc_hide_tooltip');
            }

            flag = false;
        }

        // Un-block buttons.
        if (flag) {

            setTimeout(() => {
                // Get all the fields.
                let invalidAmountFields = gwc_qsa('.give-wc-invalid-amount'),
                    isInvalidAnyForm = false;

                if (invalidAmountFields) {

                    Array.prototype.forEach.call(invalidAmountFields, (element) => {
                        let parentRow = gwc_parent(element, 'td'),
                            checkbox = gwc_qs('input[type="checkbox"].give-wc-form-selector', parentRow);

                        if (checkbox.checked) {
                            isInvalidAnyForm = true;
                        }
                    });
                }

                if (!isInvalidAnyForm) {
                    if (null !== btn_on_cart) {
                        btn_on_cart.removeAttribute('disabled');
                        tooltip.classList.add('give_wc_hide_tooltip');
                    }

                    if (null !== btn_on_checkout) {
                        btn_on_checkout.removeAttribute('disabled');
                        tooltip.classList.add('give_wc_hide_tooltip');
                    }
                }
            }, 100);

        }

        return flag;
    }

}



// WEBPACK FOOTER //
// ./assets/src/js/modules/give-wc-amount.js